import React from 'react';
import PropTypes from 'prop-types';
/* components */
import AuthWrapper from '../../components/auth-wrapper/auth-wrapper';

function EmailSentPage(props) {
    return (
        <AuthWrapper heading="Email Sent">
            <section className="sten-content__section">
                <p>
                    Instructions for password reset have been sent to
                    <span className="text-success"> {props.model.email}</span>
                </p>
                <p>Please check your email.</p>
            </section>
            <section className="sten-content__section">
                <a
                    className="btn btn--primary btn--sm col-24"
                    href={`/Account/Login?returnUrl=${encodeURIComponent(props.model.returnUrl || '/')}`}
                >
                    Back To Login
                </a>
            </section>
        </AuthWrapper>
    );
}

EmailSentPage.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default EmailSentPage;
